module.exports = __webpack_public_path__ + "img/s66XJsZKjom7y2Y2YJBRf.4f5db6bc.svg";